import { TextareaAutosize } from "@mui/material";
import { ChangeEvent } from "react";
import { UiAlert } from "../alert";

interface UiTextareaProps {
  onChange: (v: ChangeEvent<HTMLTextAreaElement>) => void;
  defaultValue?: string;
  className?: string;
  label?: string;
  placeholder?: string;
  name?: string;
  errors?: string[];
}
export function UiTextarea({
  placeholder,
  label,
  className,
  name,
  errors,
  defaultValue,
  onChange,
}: UiTextareaProps) {
  return (
    <div className="ui-textarea flex flex-col">
      {label && (
        <label className={`ui-form-label ${className || ""}`}>{label}</label>
      )}
      <TextareaAutosize
        className="border border-gray-300 rounded-md p-2"
        aria-label={label}
        placeholder={placeholder}
        defaultValue={defaultValue}
        name={name}
        minRows={4}
        style={{ width: "100%" }}
        onChange={onChange}
      />
      {errors && errors.length > 0 && (
        <UiAlert>
          {errors?.map((e) => (
            <p key={e}>{e}</p>
          ))}
        </UiAlert>
      )}
    </div>
  );
}
